import React, { Component } from 'react'
import {Alert,Label,Row,Col,Table,Input,Button,Spinner,Modal,ModalHeader,ModalBody,ModalFooter,FormGroup} from 'reactstrap'
import {connect } from 'react-redux';
import {getMainData,addMyData} from "../../Redux/ducks/mainReducer";
import ReactJsAlert from "reactjs-alert"

export class SuspendedLoans extends Component {
    state={
        isLoading:false,
        btnDisabled:false,
        mainData:null,
        searchAction:null,
        nameSearch:null,
        unsuspendModal:false,
        payModal:false,
        selectedLoan:null,
        payAmount:"",
        payDate:"",
        payDetails:"",
        alertStatus:false,
        alertType:"error",
        alertTitle:null,
    }

    componentDidMount(){
        this.setState({isLoading:true})
        this.props.getMainData("SUSPENDED_LOAN_DATA")
    }

    componentDidUpdate(prevProps){
        const{userData,msg,userDataStatus,addMyDataStatus} = this.props;
        if(userDataStatus !== prevProps.userDataStatus){
            if(userDataStatus===true){
                this.setState({isLoading:false,msg:msg,mainData:userData})
            }else{
                this.setState({isLoading:false,mainData:null,msg:msg})
            }
        }

        if(addMyDataStatus !== prevProps.addMyDataStatus){
            if(addMyDataStatus===true){
                this.setState({
                    btnDisabled:false,
                    unsuspendModal:false,
                    payModal:false,
                    selectedLoan:null,
                    payAmount:"",
                    payDetails:"",
                    alertStatus:true,
                    alertType:"success",
                    alertTitle:msg,
                    isLoading:true
                })
                this.props.getMainData("SUSPENDED_LOAN_DATA")
            }else if(addMyDataStatus===false){
                this.setState({btnDisabled:false,alertStatus:true,alertType:"error",alertTitle:msg})
            }
        }
    }

    setSearchValue = (e) =>{
        this.setState({nameSearch:e.target.value,searchAction:e.target.id})
    }

    setValue = (e) =>{
        this.setState({[e.target.name]:e.target.value})
    }

    openUnsuspendModal = (loan) =>{
        this.setState({unsuspendModal:true,selectedLoan:loan})
    }

    closeUnsuspendModal = () =>{
        this.setState({unsuspendModal:false,selectedLoan:null})
    }

    openPayModal = (loan) =>{
        const currentDate = this.state.mainData === null? "": this.state.mainData.currentDate
        this.setState({
            payModal:true,
            selectedLoan:loan,
            payAmount:"",
            payDate:currentDate || "",
            payDetails:"Suspended loan payment"
        })
    }

    closePayModal = () =>{
        this.setState({payModal:false,selectedLoan:null,payAmount:"",payDetails:""})
    }

    unsuspendLoan = () =>{
        const {selectedLoan} = this.state
        if(selectedLoan === null){
            this.setState({alertStatus:true,alertType:"error",alertTitle:"Select loan to unsuspend"})
        }else{
            const data = new FormData();
            data.append("loanID",selectedLoan.id);
            this.setState({btnDisabled:true})
            this.props.addMyData(data,"UNSUSPEND_LOAN")
        }
    }

    paySuspendedLoan = () =>{
        const {selectedLoan,payAmount,payDate,payDetails} = this.state
        if(selectedLoan === null){
            this.setState({alertStatus:true,alertType:"error",alertTitle:"Select loan to pay"})
        }else if(payAmount === ""){
            this.setState({alertStatus:true,alertType:"error",alertTitle:"Enter payment amount"})
        }else if(parseInt(payAmount) < 1){
            this.setState({alertStatus:true,alertType:"error",alertTitle:"Payment amount must be greater than zero"})
        }else if(parseInt(payAmount) > parseInt(selectedLoan.loanBalance)){
            this.setState({alertStatus:true,alertType:"error",alertTitle:"Payment cannot exceed loan balance"})
        }else{
            const data = new FormData();
            data.append("loanID",selectedLoan.id);
            data.append("amount",payAmount);
            data.append("entryDate",payDate);
            data.append("details",payDetails);
            this.setState({btnDisabled:true})
            this.props.addMyData(data,"PAY_SUSPENDED_LOAN")
        }
    }

    renderLoanRow = (values,myNo,i) => (
        <tr key={i}>
            <td>
                <Button color="success" size="sm" onClick={() => this.openUnsuspendModal(values)}>Unsuspend</Button>
            </td>
            <td><Button color="primary" size="sm" onClick={() => this.openPayModal(values)}>Pay Loan</Button></td>
            <td>{myNo}</td>
            <th scope="row">{values.loanID}</th>
            <td>{values.member.firstName+" "+values.member.lastName}</td>
            <td>{values.member.clubNumber}</td>
            <td>{values.paytype == null? "": values.paytype.name}</td>
            <td>{values.period}</td>
            <td>{values.rate}</td>
            <td>{values.amount}</td>
            <td>{values.amountExpected}</td>
            <td>{values.amountPaid}</td>
            <td>{values.loanBalance}</td>
            <td>{values.entryDate}</td>
            <td>{values.endDate}</td>
            <td>{Math.round(values.amount / values.period)}</td>
            <td>{values.suspended_reason}</td>
            <td>{values.suspendedby == null? "": values.suspendedby.firstName+" "+values.suspendedby.lastName}</td>
            <td>{values.suspended_at}</td>
        </tr>
    )

    render() {
        const {mainData,nameSearch,searchAction} = this.state;
        let suspendedLoanDataList = [];
        let myNo = 0
        let totalBalance = 0

        if(mainData !== null){
            const loanData = mainData.loanData
            if(loanData.length>0){
                loanData.forEach((values, i) =>{
                    const matchesLoan = searchAction ==="LOANID" && values.loanID === nameSearch.toUpperCase()
                    const matchesAccount = searchAction ==="ACCOUNT" && values.member.clubNumber === nameSearch.toUpperCase()
                    const hasSearch = nameSearch !== null && nameSearch !== ""

                    if(!hasSearch || matchesLoan || matchesAccount){
                        myNo = myNo+1
                        totalBalance = totalBalance+parseInt(values.loanBalance)
                        suspendedLoanDataList.push(this.renderLoanRow(values,myNo,i))
                    }
                });
            }else{
                suspendedLoanDataList.push(
                    <tr key="empty">
                        <td colSpan="19"><br/><Alert color="primary">No suspended loans found</Alert></td>
                    </tr>
                )
            }
        }

        return (
            <div>
                <Row className="mainWrraper">
                    <div className="block-header">
                        <h4>VIEW SUSPENDED LOANS</h4>
                    </div>
                    <Col xs="12" className="mainWrraper">
                        <ReactJsAlert autoCloseIn ={600000} status={this.state.alertStatus} type={this.state.alertType} title={this.state.alertTitle} Close={() => this.setState({ alertStatus: false })}/>
                        <Col xs="12" md="12" className="tableWrapper">
                            <Row>
                                <Col md="12" xs="12">
                                    <Label className='balB'>TOTAL SUSPENDED LOANS: {myNo.toLocaleString()}, TOTAL LOAN BALANCE : {totalBalance.toLocaleString()}</Label>
                                </Col>
                            </Row>
                            <div className='table-container'>
                                <Table striped responsive>
                                    <thead>
                                        <tr>
                                            <th>Action</th>
                                            <th>Pay Loan</th>
                                            <th>No.</th>
                                            <th>Loan ID</th>
                                            <th>Member</th>
                                            <th>Member No.</th>
                                            <th>Loan Type</th>
                                            <th>Period(Month)</th>
                                            <th>Rate(%)</th>
                                            <th>Loan Amount</th>
                                            <th>Amount Expected</th>
                                            <th>Amount Paid</th>
                                            <th>Opening Balance</th>
                                            <th>Entry Date</th>
                                            <th>End Date</th>
                                            <th>Installment</th>
                                            <th>Reason</th>
                                            <th>Suspended By</th>
                                            <th>Suspended At</th>
                                        </tr>
                                        <tr>
                                            <th></th>
                                            <th></th>
                                            <th></th>
                                            <th><Input type="text" className="account" onChange={this.setSearchValue} value={this.state.searchAction ==="LOANID" ?this.state.nameSearch:null} id="LOANID"/></th>
                                            <th></th>
                                            <th><Input type="text" className="account" onChange={this.setSearchValue} value={this.state.searchAction ==="ACCOUNT" ?this.state.nameSearch:null} id="ACCOUNT"/></th>
                                            <th></th>
                                            <th></th>
                                            <th></th>
                                            <th></th>
                                            <th></th>
                                            <th></th>
                                            <th></th>
                                            <th></th>
                                            <th></th>
                                            <th></th>
                                            <th></th>
                                            <th></th>
                                            <th></th>
                                        </tr>
                                    </thead>
                                    {this.state.isLoading?
                                    <tbody>
                                        <tr>
                                            <td colSpan="19">
                                                <Spinner className="mySpinner" /><Spinner className="mySpinner" type="grow"/>{'Loading...'}
                                            </td>
                                        </tr>
                                    </tbody>:
                                    <tbody>
                                        {suspendedLoanDataList}
                                    </tbody>}
                                </Table>
                            </div>
                        </Col>
                    </Col>
                </Row>

                <Modal isOpen={this.state.unsuspendModal} toggle={this.closeUnsuspendModal}>
                    <ModalHeader toggle={this.closeUnsuspendModal}>Unsuspend Loan</ModalHeader>
                    <ModalBody>
                        {this.state.selectedLoan !== null?
                        <div>
                            <FormGroup><Label className="loanLabel"><b>Loan ID:</b> {this.state.selectedLoan.loanID}</Label></FormGroup>
                            <FormGroup><Label className="loanLabel"><b>Member:</b> {this.state.selectedLoan.member.firstName+" "+this.state.selectedLoan.member.lastName}</Label></FormGroup>
                            <FormGroup><Label className="loanLabel"><b>Reason:</b> {this.state.selectedLoan.suspended_reason}</Label></FormGroup>
                        </div>:null}
                    </ModalBody>
                    <ModalFooter>
                        <Button color="secondary" onClick={this.closeUnsuspendModal}>Cancel</Button>
                        <Button color="success" disabled={this.state.btnDisabled? "disabled":null} onClick={this.unsuspendLoan}>Unsuspend Loan</Button>
                    </ModalFooter>
                </Modal>

                <Modal isOpen={this.state.payModal} toggle={this.closePayModal}>
                    <ModalHeader toggle={this.closePayModal}>Pay Suspended Loan</ModalHeader>
                    <ModalBody>
                        {this.state.selectedLoan !== null?
                        <div>
                            <FormGroup><Label className="loanLabel"><b>Loan ID:</b> {this.state.selectedLoan.loanID}</Label></FormGroup>
                            <FormGroup><Label className="loanLabel"><b>Member:</b> {this.state.selectedLoan.member.firstName+" "+this.state.selectedLoan.member.lastName}</Label></FormGroup>
                            <FormGroup><Label className="loanLabel"><b>Amount Paid:</b> {parseInt(this.state.selectedLoan.amountPaid).toLocaleString()}</Label></FormGroup>
                            <FormGroup><Label className="loanLabel"><b>Opening Balance:</b> {parseInt(this.state.selectedLoan.loanBalance).toLocaleString()}</Label></FormGroup>
                            <FormGroup>
                                <Label>Payment Date</Label>
                                <Input type="date" name="payDate" value={this.state.payDate} onChange={this.setValue}/>
                            </FormGroup>
                            <FormGroup>
                                <Label>Amount</Label>
                                <Input type="number" min={1} max={this.state.selectedLoan.loanBalance} name="payAmount" value={this.state.payAmount} onChange={this.setValue}/>
                            </FormGroup>
                            <FormGroup>
                                <Label>Details</Label>
                                <Input type="textarea" name="payDetails" value={this.state.payDetails} onChange={this.setValue}/>
                            </FormGroup>
                        </div>:null}
                    </ModalBody>
                    <ModalFooter>
                        <Button color="secondary" onClick={this.closePayModal}>Cancel</Button>
                        <Button color="primary" disabled={this.state.btnDisabled? "disabled":null} onClick={this.paySuspendedLoan}>Pay Loan</Button>
                    </ModalFooter>
                </Modal>
            </div>
        )
    }
}

const mapStateToProps = state =>({
    userDataStatus : state.mainReducer.dataStatus,
    msg : state.mainReducer.msg,
    userData : state.mainReducer.mainData,
    addMyDataStatus : state.mainReducer.addMyDataStatus,
});

export default connect(
    mapStateToProps,
    {getMainData,addMyData}
)(SuspendedLoans)
